import { render, staticRenderFns } from "./capNhatBaiViet.vue?vue&type=template&id=f553d672&"
import script from "./capNhatBaiViet.vue?vue&type=script&lang=js&"
export * from "./capNhatBaiViet.vue?vue&type=script&lang=js&"
import style0 from "./capNhatBaiViet.vue?vue&type=style&index=0&id=f553d672&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports